<template>

  <div class='dealer-info'>
    <div class='dealer-container'>
      <p>고객님은 LG유플러스 본사가 보증하는 온라인판매 인증대리점을 통해 단말기를 구입 및 이동통신서비스에 가입됩니다.</p>
      <ul>
        <li>
          <dl>
            <dt>온라인 판매 인증 대리점 </dt> 
            <dd>
              <span class='dynamic-data-temp'>{{this.$store.state.connectedCar.dealerInfo.agentName}}</span>
            </dd>
            <dt>주소 : </dt>
            <dd>
              <span class='dynamic-data-temp'>{{this.$store.state.connectedCar.dealerInfo.agentAddress}}</span> 
            </dd>  
            <dt>대표번호 : </dt>
            <dd>
              <span class='dynamic-data-temp'>{{this.$store.state.connectedCar.dealerInfo.connectedAgentTelNo}}</span> 
            </dd>  
            <dt>E-mail : </dt>
            <dd>
              <span class='dynamic-data-temp'>{{this.$store.state.connectedCar.dealerInfo.connectedEmalAddr}}</span>
            </dd>              
          </dl>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import { getFomrInfo } from "@/api/connectedCar/dealerInfo";

  export default {
    name: 'DealerInfo',
    data() {
      return {
        agentId:'',
        result: {},
        agentName:'',
        agentAddress:'',
        agentTelNo:'',
        emalAddr:''
      }
      
    },
    created() {
    },
    mounted() {
      // let params = this.getUrlParams()
      // // this.agentName = this.$store.state.connectedCar.dealerInfo.agentName
      // // this.agentAddress = this.$store.state.connectedCar.dealerInfo.agentAddress
      // // this.agentTelNo = this.$store.state.connectedCar.dealerInfo.agentTelNo
      // // this.emalAddr = this.$store.state.connectedCar.dealerInfo.emalAddr
      // getFomrInfo(params.agentId, params.formId, params.openmktCd).then(res => {
      //   // this.$store.commit('SET_CONNECTED_DEALER_INFO', res.data)     
      //   this.agentName = res.data.agentName
      //   this.agentAddress = res.data.agentAddress
      //   this.agentTelNo = res.data.agentTelNo        
      //   this.emalAddr = res.data.emalAddr        
      // }) 
    },

    methods: {
      /** 
       * Function    : getUrlParams
       * Description : Url 파라미터 값 가져오기
       **/
      getUrlParams() {
        var params = {};
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
        return params;
      },

    },
  }
</script>

<style scoped>

</style>